export default{
    msg:'',
    editar:{},
    lista:'',
    trabalhadores:'',
    tomadores:'',
}